import { EditorActions } from '~src/store/editor/constants';

const resetEditor = () => ({
    type: EditorActions.RESET,
});

export { resetEditor };
